//Server URL
import { Capacitor } from '@capacitor/core';
import { getDomain } from './domain';

// Check if running in Capacitor native app (iOS/Android)
export const isCapacitor = () => {
  return Capacitor.isNativePlatform();
};

const getBaseURL = () => {
  const capacitorApp = isCapacitor();

  if (capacitorApp) {
    const domain = getDomain();

    return `https://${domain}/api`;
  }

  return 'https://' + window.location.host + '/api'; 
};

// Get logo path based on domain
export const getLogoPath = () => {
  const domain = getDomain();

  // Return mapped logo or default ClassPep logo
  return `https://${domain}/ClassPepRecLogo.png`;
};

export default getBaseURL;
